import { useTranslation } from "react-i18next";
import { useSettingsStore } from "src/features/settings/services/useSettingsStore";
import type { ErrorResponse } from "../backend/clients/backendClient";

export function useError() {
  const { i18n } = useTranslation();
  const settingsStore = useSettingsStore();

  const getErrorMessage = (error: any) => {
    let message = error?.message ?? "Error";
    let errorCode = error?.errorCode;
    if (!errorCode && error?.response) {
      const errorResponse = JSON.parse(error?.response) as ErrorResponse;
      if (errorResponse) errorCode = errorResponse.errorCode;
    }
    if (errorCode) {
      const errorEntry = settingsStore.errorList?.errorCodes?.find(
        (e) => e.code == errorCode
      );
      if (errorEntry && errorEntry.languages) {
        message = errorEntry.languages[i18n.language === "hu" ? "HUN" : "ENG"];
      }
    }
    return message;
  };

  return { getErrorMessage };
}
